import {h, Fragment} from "preact"
import { useAppState, HistoryElement, AutocompleteElement } from '@nosto/preact'
import { useEffect } from 'preact/hooks'
import { closeSearch } from "../helpers"
import { defaultConfig, topSearches, DROPDOWN_REC_ID } from '../config'

export default function History() {

    useEffect(() => {
        if(!window.nostojs) return
        window.nostojs(api => {
            api
            .createRecommendationRequest({ includeTagging: true })
            .setElements([ DROPDOWN_REC_ID ])
            .load({ skipPageViews: true, skipEvents: true })
        })
    }, [])

    const handlePopularItemClick = (e) => {
        if(e.target.closest('.ns-popular-item')) {
            closeSearch();
        }
    }

    return (
        <div class="ns-autocomplete" data-nosto-element="autocomplete">
            <div class="ns-autocomplete-content" role="listbox">
                {/* popular searches */}
                <div>
                    <h2 id="ns-popular-suggestions" class="ns-autocomplete-heading text-body">
                        Búsquedas populares
                    </h2>
                    <ul 
                        class="ns-keywords-list list-unstyled" 
                        role="group" 
                        aria-labelledby="ns-popular-suggestions"
                        onClick={handlePopularItemClick}
                    >
                        {topSearches?.map(item => (
                            <li key={item.text} class="ns-autocomplete-list-item" aria-selected="false" role="option">
                                {item.url ? (
                                    <AutocompleteElement as="a" hit={{ url: item.url }} class="ns-popular-item">
                                        <span className="ns-keyword-text">
                                            {item.text}
                                        </span>
                                    </AutocompleteElement>
                                ) : (
                                    <HistoryElement query={{ query: item.text }} class="ns-popular-item">
                                        <span className="ns-keyword-text">
                                            {item.text}
                                        </span>
                                    </HistoryElement>
                                )}
                            </li>
                        ))}
                    </ul>
                </div>
                {/* rec */}
                <div class="nosto_element" id={DROPDOWN_REC_ID} />
            </div>
        </div >
    )
}
